/**
 * Rank History — stores rank snapshots in AsyncStorage (no server table).
 * Max 30 data points retained.
 */
import AsyncStorage from '@react-native-async-storage/async-storage';

const RANK_HISTORY_KEY = 'duel_rank_history_';
const MAX_POINTS = 30;

export interface RankSnapshot {
  date: string;   // ISO date string (YYYY-MM-DD)
  rank: number;
  total: number;
  score: number;
}

function todayKey(): string {
  return new Date().toISOString().slice(0, 10);
}

export async function recordRankSnapshot(
  userId: string,
  rank: number,
  total: number,
  score: number,
): Promise<void> {
  const key = RANK_HISTORY_KEY + userId;
  const today = todayKey();

  let history: RankSnapshot[] = [];
  try {
    const raw = await AsyncStorage.getItem(key);
    if (raw) history = JSON.parse(raw);
  } catch { /* fresh start */ }

  // Replace today's entry or append
  const idx = history.findIndex((s) => s.date === today);
  const snapshot: RankSnapshot = { date: today, rank, total, score };
  if (idx >= 0) {
    history[idx] = snapshot;
  } else {
    history.push(snapshot);
  }

  // Trim to MAX_POINTS
  if (history.length > MAX_POINTS) {
    history = history.slice(history.length - MAX_POINTS);
  }

  await AsyncStorage.setItem(key, JSON.stringify(history));
}

export async function getRankHistory(userId: string): Promise<RankSnapshot[]> {
  const key = RANK_HISTORY_KEY + userId;
  try {
    const raw = await AsyncStorage.getItem(key);
    if (raw) return JSON.parse(raw);
  } catch { /* */ }
  return [];
}
